<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <validation-observer
      :ref="contractAdditionalInformationFormRef"
      v-slot="{}"
      tag="form"
    >
      <div class="row mt-3">
        <div class="col col-sm col-12 pt-2">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span class="color-gray-7 font-16 font-weight-bold">
            Información Adicional
          </span>
        </div>
      </div>
      <div class="row py-3 mr-md-0">
        <div class="col-12 col-md-2">
          <span class="color-gray-6 d-block font-14">Fecha de Aprobación:</span>
          <span class="font-16 color-black">
            {{ data.approvalDate | date('DD/MMM/YYYY') }}
          </span>
        </div>

        <div
          :class="{
            'col-12 col-md-2': !isEvaluation,
            'col-12 col-md-3': isEvaluation,
          }"
        >
          <div v-if="isEvaluation">
            <span class="color-gray-6 d-block font-14">
              Fecha de la Evaluación Completada:
            </span>
            <span class="font-16 color-black">
              {{ data.completedEvaluationDate | date('DD/MMM/YYYY') }}
            </span>
          </div>
          <div v-else>
            <span class="color-gray-6 d-block font-14">
              Fecha de Comienzo:
            </span>
            <div v-if="!editingDate">
              <span class="font-16 color-black">
                {{ data.startDate | date('DD/MMM/YYYY') }}
              </span>

              <div v-if="canEditDate || isEvaluation" class="mt-3 text-left">
                <action-button
                  class="btn-action-size mr-2"
                  i="fas fa-edit"
                  variant="outline-success btn-success success"
                  @click="() => enableEditDate()"
                />
              </div>
            </div>
            <div v-else>
              <validation-provider
                v-slot="{ errors }"
                name="startDate"
                rules="required"
              >
                <custom-date-picker
                  v-model="model.startDate"
                  class-container="w-100"
                  :custom-error-msg="'La fecha de comienzo es requerida.'"
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                  placeholder="DD/MM/YYYY"
                />
              </validation-provider>
              <div class="mt-3 text-left">
                <action-button
                  class="btn-action-size mr-2"
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger"
                  @click="() => disableEditDate()"
                />
                <action-button
                  class="btn-action-size"
                  i="fas fa-save"
                  variant="outline-success btn-success success"
                  @click="() => save()"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="canEditDate && !isEvaluation"
          :class="{
            'col-12 col-md-2': !isEvaluation,
            'col-12 col-md-3': isEvaluation,
          }"
        >
          <span class="color-gray-6 d-block font-14">Fecha de conclusión:</span>
          <div v-if="!editingDate">
            <span class="font-16 color-black">
              {{ data.contractTerminationDate | date('DD/MMM/YYYY') }}
            </span>
          </div>
          <div v-else>
            <validation-provider
              v-slot="{ errors }"
              name="contractTerminationDate"
              rules="required"
            >
              <custom-date-picker
                v-model="model.contractTerminationDate"
                class-container="w-100"
                :custom-error-msg="'La fecha de conclusión es requerida.'"
                :error="errors[0]"
                format="dd/MMM./yyyy"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
        </div>

        <div v-if="isEvaluation" class="col-12 col-md-3">
          <div>
            <span class="color-gray-6 d-block font-14">
              Fecha redacción informe de evaluación:
            </span>
            <span class="font-16 color-black">
              {{ data.draftedDate | date('DD/MMM/YYYY') }}
            </span>
          </div>
        </div>
        <div v-if="isTherapy" class="col-12 col-md-2">
          <div>
            <span class="color-gray-6 d-block font-14">Frecuencia:</span>
            <span class="font-16 color-black">
              {{ data.frecuency | empty }}
            </span>
          </div>
        </div>
        <div v-if="isTherapy" class="col-12 col-md-2">
          <div>
            <span class="color-gray-6 d-block font-14">Modalidad:</span>
            <span class="font-16 color-black">
              {{ data.modality | empty }}
            </span>
          </div>
        </div>
        <div v-if="isTherapy" class="col-12 col-md-2">
          <div>
            <span class="color-gray-6 d-block font-14">Duración:</span>
            <span class="font-16 color-black">
              {{ data.duration | empty }}
            </span>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//constants
import { ValidationProvider } from 'vee-validate';
import objectToFormData from 'object-to-formdata';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import { updateDate as _updateDate } from '@/services/uspqrp/contract.api.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'ContractAdditionalInformation',
  components: {
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
  },
  props: {
    serviceTypeId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      model: {},
      editingDate: false,
    };
  },

  mixins: [alertMixin],
  computed: {
    isTherapy() {
      return servicesTypes.Therapy === this.serviceTypeId;
    },
    isEvaluation() {
      return servicesTypes.Evaluation === this.serviceTypeId;
    },
    canEditDate() {
      return this.userHasPermissions('rempro.editar.vigencia.contratos');
    },
    contractId() {
      return this.data.contractId;
    },
    contractAdditionalInformationFormRef() {
      if (this.editingDate) `contractAdditionalInformation${this.contractId}`;
      return 'contractAdditionalInformation';
    },
  },
  methods: {
    enableEditDate() {
      this.editingDate = true;
      this.model.startDate = this.data.startDate;
      this.model.contractTerminationDate = this.data.contractTerminationDate;
    },
    disableEditDate() {
      this.editingDate = false;
    },
    async save() {
      const isFormValid = await this.$refs[
        this.contractAdditionalInformationFormRef
      ].validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const payload = objectToFormData({
        ...this.model,
        contractId: this.contractId,
        startDate: this.model.startDate,
        contractTerminationDate: this.model.contractTerminationDate,
      });

      const { data } = await _updateDate(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });
      if (data) {
        this.ShowToast(
          `Confirmación`,
          'Registro actualizado exitosamente.',
          'success'
        );
        this.data.startDate = data.startDate;
        this.data.contractTerminationDate = data.contractTerminationDate;
        this.editingDate = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
